import angular from 'angular';
import CustomerService from './customer.service';

let CustomerServiceModule = angular.module('customer', []).service('customerService', CustomerService);

export
default CustomerServiceModule;



// WEBPACK FOOTER //
// ./app/common/customer/customer.js